import { createContext, ReactNode, useContext } from "react";
import { useAuth } from "@/_core/hooks/useAuth";
import { trpc } from "@/lib/trpc";

type CurrentSalon = {
  id: number;
  name: string;
  slug: string;
  status: string;
  planId?: number | null;
  trialEndsAt?: Date | null;
} | null;

type SalonContextValue = {
  salon: CurrentSalon;
  salonId: number | null;
  isLoading: boolean;
  hasSalon: boolean;
};

const SalonContext = createContext<SalonContextValue>({
  salon: null,
  salonId: null,
  isLoading: false,
  hasSalon: false,
});

export function SalonProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const shouldResolveSalon = Boolean(user && user.role !== "superadmin");
  const { data, isLoading } = trpc.salon.getMySalon.useQuery(undefined, {
    enabled: shouldResolveSalon,
    staleTime: 60_000,
  });
  const salon = (data ?? null) as CurrentSalon;
  const salonId = salon?.id ?? null;

  return <SalonContext.Provider value={{ salon, salonId, isLoading: shouldResolveSalon && isLoading, hasSalon: salonId !== null }}>{children}</SalonContext.Provider>;
}

export function useSalonContext() {
  return useContext(SalonContext);
}
